import posthog from 'posthog-js';

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    debug: process.env.NEXT_PUBLIC_APP_ENV === 'dev',
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    person_profiles: 'identified_only',
    disable_session_recording: true,
});

posthog.register({
    environment: process.env.NEXT_PUBLIC_APP_ENV,
    app_context: process.env.NEXT_PUBLIC_APP_CTX,
    hostname: typeof window !== 'undefined' ? window.location.hostname : undefined,
});
